import { render, staticRenderFns } from "./booksSeries.vue?vue&type=template&id=8bc7915a&"
import script from "./booksSeries.vue?vue&type=script&lang=js&"
export * from "./booksSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports